import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { FormKitFrameworkContext, createMessage } from '@formkit/core'
import { onMounted, computed } from 'vue'
import { UploadWidget, Upload } from '@grantstreet/uploads'

// See gsg-upload-input.d.ts for prop documentation

export default /*#__PURE__*/_defineComponent({
  __name: 'FormKitUpload',
  props: {
    context: {}
  },
  setup(__props: any) {

const props = __props;

/**
 * This is a FormKit wrapper for the UploadWidget widget, which interfaces with
 * the PSP Upload Service for uploading files in forms.
 */



const exceptionLogger = computed(() => {
  return props.context.node.config.rootConfig?.exceptionLogger
})

// Update the FormKit input value when the upload list changes
function updateValue (newUploads: Upload[]) {
  props.context.node.input(newUploads)
}

/**
 * Prevents form submission if the upload widget is currently in the process of
 * uploading a file.
 */
function handleIsUploading (isUploading: boolean) {
  if (isUploading) {
    props.context.node.store.set(createMessage({
      key: 'uploading',
      type: 'validation',
      blocking: true,
      visible: true,

      // XXX: We will need to translate this at some point. One way to do so
      // would be to add `meta: { messageKey: 'upload-in-progress' }` and then
      // provide locale values in formkit.config.ts. However, that would not be
      // very reusable since anyone using this plugin would have to manually
      // register those translations in their formkit.config.ts. Ideally the
      // plugin itself would be able to register locale default values, but I
      // (Ben Lind) can't find any examples of FormKit plugins doing so.
      //
      // One possible solution would be to add an <i18n> block to this component
      // and manually use t() to translate this.
      value: 'File upload in progress, please wait.',
    }))
  }
  else {
    props.context.node.store.remove('uploading')
  }
}

onMounted(() => {
  if (!exceptionLogger.value) {
    throw new Error('No exceptionLogger registered in the FormKit config. See @grantstreet/formkit README for gsgInputsPlugin usage.')
  }

  props.context.node.input([])
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(UploadWidget), {
    id: props.context.id,
    name: props.context.node.name,
    disabled: Boolean(props.context.disabled),
    "file-types": props.context.fileTypes,
    "max-file-size": props.context.maxFileSize,
    multiple: props.context.multiple,
    "source-tag": props.context.sourceTag,
    "retain-until": props.context.retainUntil,
    "exception-logger": exceptionLogger.value,
    "onUpdate:modelValue": updateValue,
    "onUpdate:isProcessing": handleIsUploading
  }, null, 8, ["id", "name", "disabled", "file-types", "max-file-size", "multiple", "source-tag", "retain-until", "exception-logger"]))
}
}

})